import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import VisionMissionMain from "./VisionMissionMain";
import Footer from "../../components/Footer";

const VisionMission = () => {
  return (
    <>
      <HeaderFour />
      <VisionMissionMain />
      <Footer />
    </>
  );
};

export default VisionMission;
